export const checkIfStringIsDate = (value: string | null): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  const parsedDate = new Date(value);

  return !Number.isNaN(parsedDate.getTime())
    && value === parsedDate.toISOString();
};
